<div class="search-field" (click)="toClick()">
  <ng-content></ng-content>
  <span *ngIf="isPlaceholderVisible" class="placeholder" [textContent]="'push-to-search' | transloco"></span>
</div>
